import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import get from "lodash/get";
import { prismicImage } from "src/common/utils/prismic-image";

import "./PlaceholdImage.scss";

// An empty Prismic image field deserialises to `{}`, and ImageModel leaves
// `dimensions` null until it is given data, so either can reach this component
// without dimensions. There is no aspect ratio to reserve in that case, so the
// placeholder padding is left off rather than computed from missing values.
const getPlaceholderPadding = (image) => {
  const width = get(image, "dimensions.width");
  const height = get(image, "dimensions.height");

  if (!width || !height) {
    return undefined;
  }

  return `${(height / width) * 100}%`;
};

const PlaceholdImage = (props) => {
  if (!get(props.image, "url")) {
    return null;
  }

  return (
    <div
      style={{ paddingTop: getPlaceholderPadding(props.image) }}
      className="PlaceholdImage__image--wrapper"
    >
      <img
        className={cx("PlaceholdImage__image", {
          [props.className]: props.className,
        })}
        src={prismicImage(props.image)}
        alt={props.image.alt}
        width={props.width}
        loading={props.noLazyLoad ? "eager" : "lazy"}
      />
    </div>
  );
};

PlaceholdImage.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  noLazyLoad: PropTypes.bool,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

export default PlaceholdImage;
